import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPackingSlipTemplatesByTeam = {
  name: "getPackingSlipTemplatesByTeam" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(packingSlipSchema),
};
